module.exports = __webpack_public_path__ + "img/gamifinna-profile.f12ed359.png";